import baseAPI from './baseAPI'


const getUserProfile = async () => {
    return await baseAPI.get('user/userprofile')
}

export default {
    getUserProfile,
}